import { ArticleOutlined, DeleteOutlined, FileUpload } from '@mui/icons-material'
import { Box, Typography } from '@mui/material'
import { ChangeEvent, Dispatch, DragEvent, Fragment, SetStateAction, useCallback, useRef } from 'react'
import { useStyles } from './styles'

interface UploadAreaProps {
  files: File[]
  setFiles: Dispatch<SetStateAction<File[]>>
  multiple?: boolean
  accept?: string
}

const UploadArea = ({ files, setFiles, multiple = false, accept = '.xls,.xlsx' }: UploadAreaProps) => {
  const classes = useStyles()
  const inputFileRef = useRef<HTMLInputElement | null>(null)

  const handleAddFile = useCallback((e: ChangeEvent<HTMLInputElement>) => {
    const localFiles = e.target.files

    if (localFiles) {
      const filesArray: File[] = Array.from(localFiles)

      if (multiple) {
        setFiles((prev) => [...prev, ...filesArray])
      } else {
        setFiles(filesArray)
      }
    }

    e.target.files = null
  }, [])

  const handleFileSelect = useCallback((e: DragEvent<HTMLDivElement>) => {
    e.preventDefault()
    const localFiles = Array.from(e.dataTransfer.files)

    if (multiple) {
      setFiles((prev) => [...prev, ...localFiles])
    } else {
      setFiles(localFiles)
    }
  }, [])

  const handelFileInputClick = () => inputFileRef.current!.click()

  const handleDragOver = (e: any) => e.preventDefault()

  const handleRemoveFile = useCallback((i: number) => {
    setFiles((prev) => prev.filter((_, index) => index !== i))
    inputFileRef.current!.value = ''
  }, [])

  return (
    <Fragment>
      <input
        hidden
        name='file'
        type='file'
        ref={inputFileRef}
        multiple={multiple}
        onChange={handleAddFile}
        accept={accept}
      />

      <Box
        className={classes.root}
        onDrop={handleFileSelect}
        onDragOver={handleDragOver}
        onClick={handelFileInputClick}
      >
        <Box className={classes.content}>
          <FileUpload fontSize='large' />
          <Typography
            variant='h6'
            component='p'
          >
            Arraste e solte ou clique para procurar
          </Typography>
          <Typography
            variant='body1'
            component='span'
          >
            Somente arquivos nos formatos xls e xslx são aceitos
          </Typography>
        </Box>
      </Box>

      {files.length > 0 && (
        <Box className={classes.fileListRoot}>
          {files.map((file, i) => (
            <Box
              key={i}
              className={classes.fileItem}
            >
              <ArticleOutlined className={classes.articleIcon} />
              <span>{file.name}</span>
              <DeleteOutlined
                className={classes.deleteIcon}
                onClick={() => handleRemoveFile(i)}
              />
            </Box>
          ))}
        </Box>
      )}
    </Fragment>
  )
}

export default UploadArea
